export interface IDictionary<T> {
    values: { [key: string]: T };

    add(key: string, value: T);
    get(key: string): T;
    remove(key: string);
    clear();
}

export class Dictionary<T> implements IDictionary<T> {
    values: { [key: string]: T };

    constructor() {
        this.values = {};
    }
    
    add(key: string, value: T) {
        if (!key) return;
        this.values[key] = value;
    }

    get(key: string): T {
        if (!key) return null;
        if (Object.prototype.hasOwnProperty.call(this.values, key)) {
            return this.values[key];
        }
    }
    
    remove(key: string) {
        if (!key) return;
        if (Object.prototype.hasOwnProperty.call(this.values, key)) {
            delete this.values[key];
        }
    }

    clear() {
        for (const key in this.values) {
            delete this.values[key];
        }
    }
}